module.exports = __webpack_public_path__ + "static/media/iconAgenda.b03232bc.svg";